import React, { MouseEventHandler, useState } from 'react';
import styles from 'styles/partials/_button.css';
import { IFormatterProps } from '../../../@types/workspaceTypes';

const DeletedFormatter = (props: IFormatterProps) => {
  const [gridStyle, setGridStyle] = useState('gridlink');

  const handleClick: MouseEventHandler = (e) => {
    e.preventDefault();
    const {
      dependentValues: { options, rowData, rowIdx },
    } = props;
    const fieldName = options.fieldName || (props as any).fieldName;

    const updated: any = {};
    if (rowData[fieldName]) {
      updated[fieldName] = false;
      setGridStyle('gridlink');
    } else {
      updated[fieldName] = true;
      setGridStyle('gridlinkDelete');
    }

    options.onGridChange({
      cellKey: fieldName,
      key: null,
      rowIdx: rowIdx,
      updated: updated,
    });
  };

  const { dependentValues } = props;

  // Don't render component if it is conditional and condition not satisfied
  const values = dependentValues;
  const options = values.options;
  const fieldName = dependentValues.options.fieldName || (props as any).fieldName;

  if (options.condition && !options.condition(values.rowData)) {
    return null;
  }

  if (!dependentValues.rowData) return <div />;
  const _url = options.url + props.value;

  let label = dependentValues.options.label || (props as any).label;

  if (options.undoLabel && values.rowData[fieldName]) {
    label = dependentValues.options.undoLabel;
  }

  let buttonStyle = styles.btnInfoSmall;

  if (options.buttonStyle) {
    buttonStyle = options.buttonStyle;
  }

  if (options.undoButtonStyle && values.rowData[fieldName]) {
    buttonStyle = options.undoButtonStyle;
  }

  return (
    <a
      onDragStart={(e) => {
        e.preventDefault();
      }}
      key={_url}
      href="#"
      onClick={handleClick}
      className={gridStyle}
      tabIndex={-1}
      title={label}
    >
      <div className={styles[buttonStyle]}>{label}</div>
    </a>
  );
};

DeletedFormatter.defaultProps = {
  fieldName: 'deleted',
  label: 'Delete',
};

export default DeletedFormatter;
